import { ReactElement } from 'react';
import { Stack, Divider } from '@mui/material';

import { useTypePartnerCompany } from '~hooks/useTypePartnerCompany';

import {
  ReportsDownloadSectionVariantBySectionRoutes,
  ReportsDownloadSectionVariantBySectionItemTasks,
  ReportsDownloadSectionVariantBySectionItems,
} from './Sections';

const ReportsDownloadSectionVariantBySections = (): ReactElement => {
  const { isCarrier } = useTypePartnerCompany();

  return (
    <Stack
      spacing={2}
      direction="row"
      divider={<Divider orientation="vertical" flexItem />}
      height="100%"
    >
      <Stack spacing={2} divider={<Divider />} flex={0.5}>
        {isCarrier && <ReportsDownloadSectionVariantBySectionRoutes />}

        <ReportsDownloadSectionVariantBySectionItemTasks />
      </Stack>

      <Stack spacing={2} divider={<Divider />} flex={0.5}>
        <ReportsDownloadSectionVariantBySectionItems />
      </Stack>
    </Stack>
  );
};

export default ReportsDownloadSectionVariantBySections;
